import React, { useState } from 'react';
import { NavLink } from "react-router-dom";
import EtawaTimesLogo from '../assets/images/logo/etawah-logo.png';
import EtawaTimesLogoText from '../assets/images/logo/etawah-times-logo-txt.png';
import '../assets/css/header.css';
import '../assets/css/mobile.css';

const Header = () => {

    const [isOpen, setIsOpen] = useState(false);

    const handleNavClick = () => {
        setIsOpen(false);
    };

    // reusable function for active class
    const getNavClass = ({ isActive }) =>
        isActive ? "nav-link active" : "nav-link";

    return (
        <div className="top-header">

            <nav className="custom-navbar navbar navbar-expand-md">
                <div className="container-fluid header-container">

                    {/* Logo */}
                    <NavLink className="navbar-brand" to="/" onClick={handleNavClick}>
                        <img className='etawa-logo' src={EtawaTimesLogo} alt='Etawah times logo' />
                    </NavLink>

                    {/* Hamburger Button */}
                    <button
                        className="navbar-toggler"
                        type="button"
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    {/* Logo Text */}
                    <div className="etawah-times-logo-text">
                        <img
                            className="etawa-logo-text"
                            src={EtawaTimesLogoText}
                            alt="Etawah Times logo text"
                        />
                    </div>

                    {/* Navbar Links */}
                    <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarsFurni">
                        <ul className="navbar-nav ms-auto mb-2 mb-md-0">

                            <li className="nav-item">
                                <NavLink
                                    to="/"
                                    end
                                    className={getNavClass}
                                    onClick={handleNavClick}
                                >
                                    Home
                                </NavLink>
                            </li>

                            <li className="nav-item">
                                <NavLink
                                    to="/news"
                                    className={getNavClass}
                                    onClick={handleNavClick}
                                >
                                    News
                                </NavLink>
                            </li>

                            <li className="nav-item">
                                <NavLink
                                    to="/blogs"
                                    className={getNavClass}
                                    onClick={handleNavClick}
                                >
                                    Blogs
                                </NavLink>
                            </li>

                            <li className="nav-item">
                                <NavLink
                                    to="/about"
                                    className={getNavClass}
                                    onClick={handleNavClick}
                                >
                                    About
                                </NavLink>
                            </li>

                            <li className="nav-item">
                                <NavLink
                                    to="/contact"
                                    className={getNavClass}
                                    onClick={handleNavClick}
                                >
                                    Contact
                                </NavLink>
                            </li>

                        </ul>
                    </div>

                </div>
            </nav>

            {/* Ticker */}
            <div className="ticker">
                <marquee behavior="scroll" direction="left" scrollamount="5">
                    <p>Voice of Etawah | Voice of People</p>
                </marquee>
            </div>

        </div>
    );
};

export default Header;
